import React from "react";
import { Link } from "react-router-dom";
import LayoutMain from "../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../Partials/LeftSidedImageCopyItem/collection";
import ProductMiniItemCollection from "../../Partials/ProductMiniItem/Collection";

const leftSidedImageCopyItemCollectionData = [
  {
    description: [
      "As each garden has its own characteristics to work with we meet onsite to gain an understanding of your requirements specific to the site and in conjunction with a short questionnaire we develop a brief for your garden area.",
      "Conceptual ideas for the space are discussed along with ideas on material selection. Inspirations from our extensive portfolio of work are discussed and we explore how they can be applied to your home.",
      "Following the site consultation a proposal for the following services will be forwarded for your consideration.",
      "Alternatively you can call or email us on the details below.",
    ],
    descriptionContent: (
      <>
        <p>
          Phone&nbsp;
          <strong>
            <Link to="tel:0293807957">(02) 9380 7957</Link>
          </strong>
        </p>
        <p>
          Email &nbsp;
          <strong>
            <Link to="mailto:imagine@thinkoutsidegardens.com.au">
              imagine@thinkoutsidegardens.com.au
            </Link>
          </strong>
        </p>
      </>
    ),
    image: "images/about1.jpg",
    title: "Consultation",
  },
];


const ProductMiniItemCollectionData = [
  {
    image : 'images/contemporary-garden-oasis-4.jpg',
    title : 'Design',
    url : '/design'
  },
  {
    image : 'images/contemporary-garden-oasis.jpg',
    title : 'Estimating',
    url : '/estimating'
  },
  {
    image : 'images/contemporary-garden-oasis-2.jpg',
    title : 'Construction',
    url : '/construction'
  },
  {
    image : 'images/contemporary-garden-oasis-3.jpg',
    title : 'Maintenance',
    url : '/maintenance'
  },
]

const PageConsultation = () => {
  return (
    <LayoutMain>
      <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className=" pt-70 pb-120 pt-sm-30 pb-sm-40">
        <div className="container-3">
            <div className="row">
            <ProductMiniItemCollection data={ProductMiniItemCollectionData} />
            </div>
            </div>
            </section>
    </LayoutMain>
  );
};

export default PageConsultation;
